import { getAccountEvents, getAccountsOfMarketplace, getEventOrdersOfEvent } from "../api";
import pLimit from 'p-limit';

export const MarketService = {
    async getMarketPlaceSaleStatsData(marketPlaceId) {
        // Create concurrency limiter - max 30 concurrent requests to prevent server overload
        const limit = pLimit(30);

        // Step 1: Get all marketplace accounts
        const marketplaceAccounts = await getAccountsOfMarketplace(marketPlaceId);

        // Step 2: Fetch events for each account with controlled concurrency
        const eventsPromises = marketplaceAccounts.data.map(account =>
            limit(() => getAccountEvents(account._id))
        );
        let events = await Promise.all(eventsPromises);
        events = events.map(eventData => eventData.data).flat();

        // Step 3: Fetch orders for each event with controlled concurrency
        const eventOrdersPromises = events.map(event =>
            limit(() => getEventOrdersOfEvent({ accountId: event.account, eventId: event._id }))
        );
        let eventOrders = await Promise.all(eventOrdersPromises);
        eventOrders = eventOrders.map(eventOrderData => eventOrderData.data).flat();

        return {
            accounts: marketplaceAccounts.data,
            events,
            eventOrders
        };
    }
}
